import { Drawer as MUIDrawer } from "@mui/material";
import { Button } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";

export const StyledContainer = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey) {
            return propName !== "maxWidth" && propName !== "variant";
        },
    }
)<{ maxWidth: number; variant: "wide" | "narrow" | "fullWidth" }>(({ theme, maxWidth, variant }) => {
    const isWide = variant === "wide";
    const isFullWidth = variant === "fullWidth";
    return {
        position: "relative",
        width: "100vw",
        height: "100vh",
        overflowY: "auto",
        boxSizing: "border-box",
        padding: isFullWidth ? 0 : `${isWide ? theme.spacing(4) : theme.spacing(3)} ${theme.spacing(2)}`,
        [theme.breakpoints.up("sm")]: {
            maxWidth,
            width: `calc(100vw - ${theme.spacing(8)})`,
            padding: isFullWidth ? 0 : `${isWide ? theme.spacing(4) : theme.spacing(3)} ${theme.spacing(5)}`,
        },
    };
});

export const StyledCloseButton = styled(Button)(({ theme }) => ({
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: theme.kaltura.palette.translucent.dark,
    color: theme.kaltura.palette.translucent.light,
    [theme.breakpoints.up("sm")]: {
        top: theme.spacing(2),
        right: `calc(100% + ${theme.spacing(2)})`,
    },
    zIndex: 1,
}));

export const StyledTranslucentCloseButton = styled(Button)(({ theme }) => ({
    position: "absolute",
    top: theme.spacing(2),
    right: `calc(100% - ${theme.spacing(6)})`,
    zIndex: 1,
}));

export const StyledDrawer = styled(
    MUIDrawer,
    {
        shouldForwardProp: (prop) => !["maxWidth", "contentContainerVariant", "backgroundVariant"].includes(prop),
    }
)(({ theme }) => ({
    zIndex: theme.zIndex.modal,
}));
